/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `equals` - equals
 * * `not_equals` - not_equals
 * @export
 */
export const CustomQuestionnaireQuestionRuleConditionOperatorEnum = {
  equals: 'equals',
  notEquals: 'not_equals',
} as const;
export type CustomQuestionnaireQuestionRuleConditionOperatorEnum =
  (typeof CustomQuestionnaireQuestionRuleConditionOperatorEnum)[keyof typeof CustomQuestionnaireQuestionRuleConditionOperatorEnum];

export function instanceOfCustomQuestionnaireQuestionRuleConditionOperatorEnum(value: any): boolean {
  for (const key in CustomQuestionnaireQuestionRuleConditionOperatorEnum) {
    if (Object.prototype.hasOwnProperty.call(CustomQuestionnaireQuestionRuleConditionOperatorEnum, key)) {
      if (
        (
          CustomQuestionnaireQuestionRuleConditionOperatorEnum as Record<
            string,
            CustomQuestionnaireQuestionRuleConditionOperatorEnum
          >
        )[key] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function CustomQuestionnaireQuestionRuleConditionOperatorEnumFromJSON(
  json: any,
): CustomQuestionnaireQuestionRuleConditionOperatorEnum {
  return CustomQuestionnaireQuestionRuleConditionOperatorEnumFromJSONTyped(json, false);
}

export function CustomQuestionnaireQuestionRuleConditionOperatorEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireQuestionRuleConditionOperatorEnum {
  return json as CustomQuestionnaireQuestionRuleConditionOperatorEnum;
}

export function CustomQuestionnaireQuestionRuleConditionOperatorEnumToJSON(
  value?: CustomQuestionnaireQuestionRuleConditionOperatorEnum | null,
): any {
  return value as any;
}
